module.exports = __webpack_public_path__ + "static/assets/cf61d732295f5f94dd902fbbad31cf90.png";